import React from "react"

import { DefaultLayout } from "../layouts"
import { Hero, SEO, Section, Feature } from "../components"

const features = [
  {
    title: "Increase your reach even further 🌏",
    text: (
      <>
        <p>
          Integrate your <strong>Neto eCommerce webstore</strong> with new
          marketplaces, opening up new sales channels.{" "}
          <strong>Connect multiple accounts</strong> at the same marketplace to
          the same Neto eCommerce webstore.
        </p>
        <p>
          Orders are synchronised from your marketplace account directly into
          your Neto Control Panel, ready to process just like any other order.
          Once dispatched, the order tracking information is immediately sent
          back to the marketplace; improving your relationship with your new
          customers.
        </p>
      </>
    ),
  },
  {
    title: "Blazing fast, reliable integrations 🔥",
    text: (
      <>
        <p>
          Where possible, Kovalt uses <strong>webhooks</strong> which means it
          can respond to new changes instantly. You will spend less time
          thinking about when orders are coming and more time actually
          processing them.
        </p>
        <p>
          Only the concise data that you and your marketplace account cares
          about is synchronised; this means that each synchronisation completes
          in a few moments.
        </p>
      </>
    ),
  },
  {
    title: "Customisable to fit any requirement 🔀",
    text: (
      <>
        <p>
          Pick and choose which product fields you want to synchronise to each
          marketplace.
        </p>
        <p>
          Use any of our pre-defined product field mappings if you'd rather
          <strong> start selling sooner</strong>.
        </p>
      </>
    ),
  },
  {
    title: "We don't want your data 🔒",
    text: (
      <>
        <p>
          It is becoming more common for marketplaces to practice
          anti-competitive behaviour and abuse the data that their sellers
          provide.
        </p>
        <p>
          Rather than provide a marketplace with direct access to your Neto
          eCommerce account, Kovalt can act as a middle man that only provides
          marketplaces with the data they need to sell your products.
        </p>
        <p>
          We have no interest in your sensitive data and will <strong>never</strong> share
          it with a third party.
        </p>
      </>
    ),
  },
]

const FeaturesPage = () => (
  <DefaultLayout>
    <SEO title="Features" />
    <Section>
      <Hero primaryText="Features" />
    </Section>
    <Section>
      {features.map((props, k) => (
        <Feature key={k} {...props} />
      ))}
      <Feature
        title="Have other questions?"
        text={
          <>
            <p>
              Contact the team at{" "}
              <a href="mailto:hello@kovalt.io">hello@kovalt.io</a> for more
              information or a demo.
            </p>
          </>
        }
      />
    </Section>
  </DefaultLayout>
)

export default FeaturesPage
